import React, { useState } from 'react'
import { Dialog, Card } from '../../Elements'
import { Table, Row, Col } from '../../Elements'
import { Classes, NonIdealState, Switch, Divider } from '@blueprintjs/core'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { useMediaQuery } from 'react-responsive'

const dialogStyles = {
    width: '600px',
}

const dialogBodyStyles = {
    maxHeight: '400px',
    overflow: 'auto'
}

const tableHeaderStyle = {
    top: 110,
    zIndex: 5,
    backgroundColor: 'white',
    borderBottom: '1px gray solid',
    paddingTop: 0
}

const tableRowUnreadStyle = {
    fontWeight: 'bold',
    fontSize: '12pt'
}

const tableRowReadStyle = {
    fontWeight: 'normal',
    fontSize: '10pt'
}

const NotificationCard = ({ notification, markNotificationRead, setNotificationsDialogIsOpen, navigateToActionUrl }) => {
    return (
        <Card key={`notification-card-${notification.id}`} className='mobile-search-result-card'>
            <div
                style={notification.is_read
                    ? { ...tableRowReadStyle, overflowX: 'hidden' }
                    : { ...tableRowUnreadStyle, overflowX: 'hidden' }}
                onClick={() => {
                    markNotificationRead(notification.id)
                    setNotificationsDialogIsOpen(false)
                    navigateToActionUrl(notification.action_url)
                }}
            >
                <p>{`${moment(notification.created_date).format('MM/DD/YY')}, ${moment(notification.created_date).format('h:mm a')}`}</p>
                <Divider />
                <p>{notification.notification_text}</p>
            </div>
        </Card>
    )
}

export const NotificationsDialog = ({ allNotifications, notificationsDialogIsOpen, setNotificationsDialogIsOpen, markNotificationRead }) => {
    const [showRead, setShowRead] = useState(false)
    const isNotFullSize = useMediaQuery({ query: '(max-width: 1255px)' })
    const navigate = useNavigate()
    const navigateToActionUrl = (url) => navigate(url)

    const notificationsToShow = showRead
        ? allNotifications
        : allNotifications.filter(n => !n.is_read)

    return (
        <Dialog
            style={dialogStyles}
            icon='notifications'
            title={showRead ? 'Notifications' : 'Unread Notifications'}
            isOpen={notificationsDialogIsOpen}
            canOutsideClickClose={true}
            canEscapeKeyClose={true}
            isCloseButtonShown={true}
            onClose={() => setNotificationsDialogIsOpen(false)}
        >
            <div className={Classes.DIALOG_BODY} style={dialogBodyStyles}>
                <Card>
                    <Row>
                        <Col xs={12}>
                            <Switch
                                innerLabel='Include Read Notifications'
                                onChange={() => { setShowRead(!showRead) }}
                                style={{ float: 'right' }}
                                checked={showRead}
                            />
                        </Col>
                    </Row>
                    {notificationsToShow.length > 0
                        ?
                        !isNotFullSize
                            ?
                            <Row>
                                <Col xs={12}>
                                    <Table style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th style={tableHeaderStyle} > Created </th>
                                                <th style={tableHeaderStyle} > Message </th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {notificationsToShow.sort(n => n.created_date).map(notification => (
                                                <tr
                                                    key={notification.id}
                                                    style={notification.is_read ? tableRowReadStyle : tableRowUnreadStyle}
                                                    onDoubleClick={() => {
                                                        markNotificationRead(notification.id)
                                                        setNotificationsDialogIsOpen(false)
                                                        navigateToActionUrl(notification.action_url)
                                                    }}>
                                                    <td>
                                                        <div>{`${moment(notification.created_date).format('MM/DD/YY')},`}</div>
                                                        <div>{moment(notification.created_date).format('h:mm a')}</div>
                                                    </td>
                                                    <td>{notification.notification_text}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            :
                            <Row>
                                {notificationsToShow.sort(n => n.created_date).map(notification => (
                                    <Col xs={6} sm={4} md={6} key={`col-notification-${notification.id}`}>
                                        <NotificationCard
                                            notification={notification}
                                            markNotificationRead={markNotificationRead}
                                            setNotificationsDialogIsOpen={setNotificationsDialogIsOpen}
                                            navigateToActionUrl={navigateToActionUrl}/>
                                    </Col>
                                ))
                                }
                            </Row>
                        :
                        <NonIdealState
                            icon='search'
                            title={showRead ? 'No notifications found.' : 'No unread notifications found.'}
                        />}
                </Card>
            </div>
        </Dialog>
    )
}